module.exports = __webpack_public_path__ + "static/media/falhas.983cb10d.jpg";